/*
    MLB Wind Direction Component
    This component is used to display the wind direction for a given game over an icon of the field.

    Props: 
        - stadiumDirection: the direction the batter is facing when looking at the pitcher's mound
        - windDirection: the direction the wind is blowing

    If the stadiumDirection or windDirection is not provided, the component should N/A.
    The component should calculate the number of degrees the diamond would need to be rotated (counter clockwise) to ensure home plate is facing north (0 degrees).
    The component should then rotate the direction icon the name number of degrees to the left.

*/

import React from 'react';
import field from '../../../assets/images/icons/baseball-field.svg';
import { ArrowLongUpIcon } from '@heroicons/react/24/solid';

const MlbWindDirection = ({stadiumDegrees, windDegrees}) => {
    // If either prop is missing, display N/A
    if (!stadiumDegrees || !windDegrees) {
        return (
            <div className="flex flex-col items-center justify-center w-24 h-24 bg-gray-100 dark:bg-gray-800 rounded-lg">
                <div className="text-gray-500 dark:text-gray-400 text-sm font-medium">Direction</div>
                <div className="text-gray-500 dark:text-gray-400 text-sm font-medium">N/A</div>
            </div>
        );
    }

    function getArrowAngle(windDirection, stadiumDegrees) {
        const blowingToward = (windDirection + 180) % 360;
        const relativeArrowAngle = (blowingToward - stadiumDegrees + 360) % 360;

        return relativeArrowAngle;
    };

    let relativeWindDirection = getArrowAngle(windDegrees, stadiumDegrees);

    return (
        <div className="relative w-24 h-24 flex items-center justify-center">
            {/* Baseball diamond - no rotation */}
            <img 
                src={field} 
                alt="Baseball diamond" 
                className="w-full h-full object-contain"
            />
            
            {/* Wind direction arrow - centered and rotated based on relative wind direction */}
            <div 
                className="absolute flex items-center justify-center rounded-full bg-gray-700"
                style={{
                    width: '30px',
                    height: '30px',
                }}
            >
                <ArrowLongUpIcon 
                    className="w-5 h-5 text-white dark:text-gray-300"
                    style={{
                        transform: `rotate(${relativeWindDirection}deg)`,
                        transformOrigin: 'center'
                    }}
                />
            </div>
        </div>
    )
}

export default MlbWindDirection;